import Request from '../services/Request'

export default class AlixRepository {
    /**
     * @returns {Promise<any>}
     */
    static getSuggestedAnswers(ratingUuid) {
        return new Promise((resolve, reject) => {
            Request
                .make('GET', '/ratings/'+ratingUuid+'/suggested-answers')
                .then(({data}) => {
                    resolve(data);
                })
                .catch((error) => {
                    reject(error)
                })
        });
    }

    /**
     * @returns {Promise<any>}
     */
    static postAnswer(ratingUuid, body = {}) {
        return new Promise((resolve, reject) => {
            Request
                .make('POST', '/ratings/'+ratingUuid+'/answer', body)
                .then((result) => resolve(result))
                .catch((error) => reject(error))
        });
    }
    /**
     * @returns {Promise<any>}
     */
    static updateAnswer(ratingUuid, answerUuid, body = {}) {
        return new Promise((resolve, reject) => {
            Request
                .make('PUT', '/ratings/'+ratingUuid+'/answer/'+answerUuid, body)
                .then((result) => resolve(result))
                .catch((error) => reject(error))
        });
    }

    /**
     * @returns {Promise<any>}
     */
    static deleteAnswer(ratingUuid) {
        return new Promise((resolve, reject) => {
            Request
                .make('DELETE', '/ratings/'+ratingUuid+'/answer')
                .then(({data}) => {
                    resolve(data);
                })
                .catch((error) => {
                    reject(error)
                })
        });
    }

    static predictLanguages(ratingIds) {
        return new Promise((resolve, reject) => {
            Request
                .make('POST', '/ratings/predict-languages', { rating_ids: ratingIds })
                .then((result) => resolve(result))
                .catch((error) => reject(error))
        });
    }

    // Export creation
    static createExport(body = {}) {
        return new Promise((resolve, reject) => {
            Request
                .make('POST', '/exports/data/', body)
                .then((result) => resolve(result))
                .catch((error) => reject(error))
        });
    }

    // List user exports from S3 via backend proxy
    static listUserExports() {
        return new Promise((resolve, reject) => {
            Request
                .make('GET', '/exports/')
                .then((result) => resolve(result))
                .catch((error) => reject(error))
        });
    }

    // Get a signed url to download a specific export
    static downloadExport(filename, config = {}) {
        return new Promise((resolve, reject) => {
            Request
                .make('GET', '/exports/download/'+filename, config)
                .then((result) => resolve(result))
                .catch((error) => reject(error))
        });
    }
}

